import { call, put } from 'redux-saga/effects'

import PaymentActions from '../reducers/paymentRedux'

export function* getPaymentInfo(api, action) {
    var response = yield call(api.getPaymentInfo, action.caseId);
    if (response && response.ok && response.data) {
        yield put(PaymentActions.setPaymentInfo(response.data))
    } else if (response && response.ok && !response.data) {
        // API returned 204 No Content, set empty array
        yield put(PaymentActions.setPaymentInfo([]))
    }   
}

export function* completePayment(api, action) {
    var response = yield call(api.completePayment, action.url);
    if (response && response.ok) {
        yield put(PaymentActions.setPaymentInfo(response.data))
    }
}